import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=6359fd22&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=6359fd22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6359fd22"]])

export default __exports__